export var PlaybackState;
(function (PlaybackState) {
    PlaybackState["NONE"] = "NONE";
    PlaybackState["LOADING"] = "LOADING";
    PlaybackState["PLAYING"] = "PLAYING";
    PlaybackState["STOPPED"] = "STOPPED";
})(PlaybackState || (PlaybackState = {}));
//# sourceMappingURL=PlaybackState.js.map